"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AuthSchema = exports.AUTH_DEBUG_TOKEN_VALIDITY_EXPIRED = exports.AUTH_GLOBAL_SECURITY_ERROR = exports.AUTH_DISMISS_ERROR = exports.AUTH_LOGOUT = exports.AUTH_LOGIN_FAILED = exports.AUTH_LOGIN_SUCCESS = exports.AUTH_LOGIN = undefined;

var _handleActions;

var _lodash = require("lodash");

var _constants = require("redux-persist/constants");

var _reduxActions = require("redux-actions");

var _tcomb = require("tcomb");

var t = _interopRequireWildcard(_tcomb);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Define the action constants this reducer handles and exports for its actions
// structure is based on https://github.com/erikras/ducks-modular-redux
var AUTH_LOGIN = exports.AUTH_LOGIN = "auth/LOGIN";
var AUTH_LOGIN_SUCCESS = exports.AUTH_LOGIN_SUCCESS = "auth/LOGIN_SUCCESS";
var AUTH_LOGIN_FAILED = exports.AUTH_LOGIN_FAILED = "auth/LOGIN_FAILED";
var AUTH_LOGOUT = exports.AUTH_LOGOUT = "auth/LOGOUT";
var AUTH_DISMISS_ERROR = exports.AUTH_DISMISS_ERROR = "auth/DISMISS_ERROR";
var AUTH_GLOBAL_SECURITY_ERROR = exports.AUTH_GLOBAL_SECURITY_ERROR = "auth/AUTH_GLOBAL_SECURITY_ERROR";
var AUTH_DEBUG_TOKEN_VALIDITY_EXPIRED = exports.AUTH_DEBUG_TOKEN_VALIDITY_EXPIRED = "auth/AUTH_DEBUG_TOKEN_VALIDITY_EXPIRED";

// Define the state schema this reducer complies to and export it so this can be reused.
var AuthSchema = exports.AuthSchema = t.struct({
    isAuthenticated: t.Boolean,
    username: t.maybe(t.String),
    shouldRememberUser: t.Boolean,
    accessToken: t.maybe(t.String),
    refreshToken: t.maybe(t.String),
    expiresAt: t.maybe(t.Date),
    scope: t.list(t.String),
    highestPermission: t.maybe(t.String),
    isLoading: t.Boolean,
    error: t.maybe(t.String),
    errorStatus: t.maybe(t.Number),
    guildId: t.maybe(t.Number)
}, "AuthSchema");
// Define the initial state of this reducer (must conform to the above Schema)
var initialState = AuthSchema({
    isAuthenticated: false,
    username: null,
    shouldRememberUser: true,
    accessToken: null,
    refreshToken: null,
    expiresAt: null,
    scope: [],
    isLoading: false,
    error: null,
    highestPermission: null,
    errorStatus: null,
    guildId: null
});
exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, AUTH_LOGIN, function (state, action) {
    return AuthSchema.update(state, {
        isAuthenticated: {
            $set: false
        },
        username: {
            $set: action.payload.username
        },
        shouldRememberUser: {
            $set: action.payload.shouldRememberUser
        },
        isLoading: {
            $set: true
        },
        error: {
            $set: null
        },
        errorStatus: {
            $set: null
        }
    });
}), _defineProperty(_handleActions, AUTH_LOGIN_SUCCESS, function (state, action) {
    var payload = action.payload;
    var highestPermission = null;
    if ((0, _lodash.includes)(payload.scope, "ishap")) {
        highestPermission = "ishap";
    } else if ((0, _lodash.includes)(payload.scope, "guild")) {
        highestPermission = "guild";
    } else if ((0, _lodash.includes)(payload.scope, "manager")) {
        highestPermission = "manager";
    } else if ((0, _lodash.includes)(payload.scope, "user")) {
        highestPermission = "user";
    }
    return AuthSchema.update(state, {
        isAuthenticated: {
            $set: true
        },
        accessToken: {
            $set: payload.accessToken
        },
        refreshToken: {
            $set: payload.refreshToken
        },
        scope: {
            $set: payload.scope
        },
        highestPermission: {
            $set: highestPermission
        },
        expiresAt: {
            $set: payload.expiresAt
        },
        isLoading: {
            $set: false
        },
        guildId: {
            $set: payload.guildId
        }
    });
}), _defineProperty(_handleActions, AUTH_LOGIN_FAILED, function (state, action) {
    var payload = action.payload;
    return AuthSchema.update(state, {
        isLoading: {
            $set: false
        },
        error: {
            $set: action.error
        },
        errorStatus: {
            $set: payload.errorStatus
        }
    });
}), _defineProperty(_handleActions, AUTH_LOGOUT, function (state, action) {
    return AuthSchema.update(state, {
        isAuthenticated: {
            $set: false
        },
        username: {
            $set: state.shouldRememberUser ? state.username : null
        },
        shouldRememberUser: {
            $set: state.shouldRememberUser
        },
        accessToken: {
            $set: null
        },
        refreshToken: {
            $set: null
        },
        scope: {
            $set: []
        },
        highestPermission: {
            $set: null
        },
        expiresAt: {
            $set: null
        },
        isLoading: {
            $set: false
        },
        error: {
            $set: null
        },
        guildId: {
            $set: null
        }
    });
}), _defineProperty(_handleActions, AUTH_DISMISS_ERROR, function (state, action) {
    return AuthSchema.update(state, {
        error: {
            $set: null
        },
        errorStatus: {
            $set: null
        }
    });
}), _defineProperty(_handleActions, AUTH_GLOBAL_SECURITY_ERROR, function (state, action) {
    var auth = action.payload;
    return AuthSchema.update(state, {
        isAuthenticated: {
            $set: false
        },
        isLoading: {
            $set: false
        },
        error: {
            $set: action.error
        },
        errorStatus: {
            $set: auth.errorStatus
        }
    });
}), _defineProperty(_handleActions, AUTH_DEBUG_TOKEN_VALIDITY_EXPIRED, function (state, action) {
    return AuthSchema.update(state, {
        accessToken: {
            $set: "INVALID_ACCESS_TOKEN"
        },
        refreshToken: {
            $set: "INVALID_REFRESH_TOKEN"
        }
    });
}), _defineProperty(_handleActions, _constants.REHYDRATE, function (state, action) {
    var auth = action.payload.auth; // JSON stringify, not IAuth - e.g. expiresAt = Date
    var highestPermission = null;
    try {
        if ((0, _lodash.includes)(auth.scope, "ishap")) {
            highestPermission = "ishap";
        } else if ((0, _lodash.includes)(auth.scope, "guild")) {
            highestPermission = "guild";
        } else if ((0, _lodash.includes)(auth.scope, "manager")) {
            highestPermission = "manager";
        } else if ((0, _lodash.includes)(auth.scope, "user")) {
            highestPermission = "user";
        }
        // console.log(auth);
        var mergedState = AuthSchema.update(state, {
            isAuthenticated: {
                $set: auth.isAuthenticated
            },
            username: {
                $set: auth.username
            },
            shouldRememberUser: {
                $set: auth.shouldRememberUser
            },
            accessToken: {
                $set: auth.accessToken
            },
            refreshToken: {
                $set: auth.refreshToken
            },
            highestPermission: {
                $set: highestPermission
            },
            scope: {
                $set: auth.scope
            },
            expiresAt: {
                $set: new Date(auth.expiresAt)
            },
            guildId: {
                $set: auth.guildId
            }
        });
        return mergedState;
    } catch (e) {
        return state;
    }
}), _handleActions), initialState);


/*****************
 ** WEBPACK FOOTER
 ** ./src/reducers/auth/index.ts
 ** module id = 157
 ** module chunks = 0
 **/